<template>
  <q-layout>
    <q-page-container>
  <q-page class="bg-login window-height window-width row justify-center items-center">
    <div class="column">

      <div class="row">
        <q-form
            @submit="onSubmit"
            @reset="onReset"
            class="q-gutter-md"
            :class='{ "q-gutter-md" : true, "q-py-xl" : this.embed }'
        >
        <q-card  class="q-pa-lg">
          <q-card-section>

            <div class="mw-form-v2-logo" v-if="logo">
              <img v-if="logo" :src="logo" class="mw-form-v2-logo-img" />
            </div>

              <h5 class="text-h5 q-my-md">Sign In</h5>
              <q-input square filled  v-model="email" label="email"

                       :rules=" [

            val => !!val || '* Required',
            val => val.length > 4 || 'Please use minimum 5 chars',
            val => isValidEmail() || 'Please type valid email address'

            ]"
                       :disable="isSending"
              >
                <template v-slot:append>
                  <q-icon name="s_email" />
                </template>
              </q-input>
              <q-input square filled  v-model="password" label="password"
                       :rules="[ val => val && val.length > 0 || 'Password is required']"
                       :type="isPwd ? 'password' : 'text'"
                       :disable="isSending"
              >
                <template v-slot:append>
                  <q-icon
                      :name="isPwd ? fasEye : fasEyeSlash"
                      class="cursor-pointer"
                      @click="isPwd = !isPwd"
                  />
                </template>
              </q-input>
            <p class="text-grey-6 q-mb-none text-right"><router-link to="/forgot-password" class="text-primary text-decoration-none">
              <span class="text-weight-bolder ">Forgot password?</span>
            </router-link>
            </p>

          </q-card-section>
          <q-card-actions class="q-px-md">
            <q-btn :loading="isSending" unelevated type="submit" color="primary" size="lg" class="full-width" label="Login" />
          </q-card-actions>
          <q-card-section class="text-center q-pa-none" v-if="!isSending">
            <p class="text-grey-6">Do not have an account?  <router-link to="/signup" class="text-primary text-decoration-none">
              <span class="text-weight-bolder ">Sign Up</span>
              </router-link>
            </p>

          </q-card-section>
          <q-separator v-if="!isSending"></q-separator>
          <q-card-section class="text-center q-pa-none" v-if="!isSending">
            <p class="text-grey-6 q-mt-md">Or Login Using </p>
            <GoogleLogin popup-type="TOKEN" :callback="googleCallback">
              <q-btn :icon="fabGoogle" />
            </GoogleLogin>
          </q-card-section>
        </q-card>
        </q-form>
      </div>
    </div>
  </q-page>
      </q-page-container>
        </q-layout>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import {fabGoogle, fasEye, fasEyeSlash} from "@quasar/extras/fontawesome-v5"
import {fetchEnv} from "@/helpers/form";
import {getRedirectParam} from "@/helpers/form";
import {Loading,Notify} from "quasar";
import {mapActions} from "vuex";

export default {
  name: 'LoginComponent',
  data () {
    return {
      email: '',
      password: '',
      fabGoogle,
      isSending: false,
      fasEye,
      fasEyeSlash,
      isPwd: true,
      embed: false
    }
  },
  computed: {
    ...mapFields('values/list', {
      logo: "logo"
    }),
    ...mapFields('settings/list', {
      form: 'form'
    })
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.embed = urlParams.get('embed');
    this.initResize();
  },
  created () {
    this.fabGoogle = fabGoogle;
    this.fasEye = fasEye;
    this.fasEyeSlash = fasEyeSlash;
  },
  methods: {
    ...mapActions({
      authenticateUser: 'settings/list/authenticateUser',
    }),
    googleCallback(response) {
      // This callback will be triggered when the user selects or login to
      // his Google account from the popup
      this.isSending = true;
      fetchEnv('/front/api/v1/google/login', {
        code: response.access_token
      })
          .then(
              (response) => {
                this.isSending = false;
                if(response.authenticated === undefined || !response.authenticated) {
                  let errorBlock = '';
                  for(let key in response.error) {
                    errorBlock += '<p style="color: red">'+response.error[key]+'</p>';
                  }
                  Notify.create(  //'Something went wrong');
                      {
                        message: '<p><em>Something went wrong</em></p>' + errorBlock,
                        html: true,
                        timeout:5000
                      });
                  //console.log(response);
                } else {
                  //Notify.create('Submitted');
                  this.authenticateUser(response);
                  this.isSent = true;

                  Loading.show({group: 'redirect'});
                  getRedirectParam().then(redirectData => {
                    if(Object.hasOwn(redirectData,'redirect') && redirectData.redirect !== undefined  && redirectData.redirect) {
                      document.location = redirectData.redirect;
                    } else {
                      Loading.hide('redirect');
                      this.$router.push('/forms');
                    }
                  });
                }
              })
          .catch(error => console.log(error));
    },
    onSubmit () {
      this.isSending = true;
      this.recaptcha();

    },
    async recaptcha() {

      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('login')

      fetchEnv('/front/api/v1/login', {
        token,
        email: this.email,
        password: this.password,
      })
          .then(
              (response) => {
                this.isSending = false;
                if(response.authenticated === undefined || !response.authenticated) {
                  let errorBlock = '';
                  for(let key in response.error) {
                    errorBlock += '<p style="color: red">'+response.error[key]+'</p>';
                  }
                  if(errorBlock) {
                    Notify.create(  //'Something went wrong');
                        {
                          message: '<p><em>Something went wrong</em></p>' + errorBlock,
                          html: true,
                          timeout: 5000
                        });
                  } else {
                        Notify.create(
                        {
                          message: response.message,
                          html: true,
                          timeout: 5000
                        });
                  }
                  console.log('login log');
                } else {
                  //Notify.create('Submitted');
                  this.authenticateUser(response);
                  this.isSent = true;
                  Loading.show({group: 'redirect'});
                  getRedirectParam().then(redirectData => {
                    if(Object.hasOwn(redirectData,'redirect') && redirectData.redirect !== undefined  && redirectData.redirect) {
                      document.location = redirectData.redirect;
                    } else {
                      Loading.hide('redirect');
                      this.$router.push('/forms');
                    }
                  });
                }
              })
          .catch(error => console.log(error));
    },
    onReset () {

    },
    isValidEmail() {
      try {
        //eslint-disable-next-line
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email);
      } catch (e) {
        console.log(e);
      }
      return false;
    },
    initResize () {
      // create an Observer instance
      const resizeObserver = new ResizeObserver(() => {
            //console.log('Body height changed:', entries[0].target.clientHeight);
            const urlParams = new URLSearchParams(window.location.search);
            const id = urlParams.get('id');
            const message = JSON.stringify({
              message: 'resize',
              id: id,
              scrollHeight: document.body.scrollHeight
            });
            window.parent.postMessage(message, '*');
          }
      )
      resizeObserver.observe(document.body);
    }
  },
}
</script>

<style scoped>
.q-card {
  width: 360px;
}
.text-decoration-none {
  text-decoration: none;
}

.mw-form-v2-logo-img {
  max-width: 100%;
  max-height: 150px;
}
</style>